import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CustomMenuService } from './custom-menu.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ConfirmDialogService } from 'src/app/common/components/confirm-dialog/confirm-dialog.service';
import { ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-custom-menu',
  standalone: false,
  templateUrl: './custom-menu.component.html',
  styleUrl: './custom-menu.component.scss'
})
export class CustomMenuComponent implements OnInit, DirtyCheck {

  menuItems = [
    { key: 'is_userdefined_page1_active', label: 'User Define menu1', value: true, type: 'checkbox' },
    { key: 'userdefined_page1_caption', value: 'Sushi Manager Extra', type: 'text' },
    { key: 'is_userdefined_page2_active', label: 'User Define menu2', value: true, type: 'checkbox' },
    { key: 'userdefined_page2_caption', value: 'Assistant Manager', type: 'text' },
    { key: 'is_userdefined_page3_active', label: 'User Define menu3', value: true, type: 'checkbox' },
    { key: 'userdefined_page3_caption', value: 'Trainee Manager', type: 'text' }
  ];

  formData: any = {};
  canEdit = true;
  isSaving = false;
  customMenuId: number | null = null;
  isFormDirty = false;

  constructor(private http: HttpClient,
    private customMenuService: CustomMenuService,
    private snackBarService: SnackBarService,
    private router: Router,
    private confirmDialogService: ConfirmDialogService
  ) { }
  
  isDirty(): boolean {
    return this.isFormDirty;
  }


  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.customMenuService.getCustomMenuList().subscribe((response: any) => {
      if (response.status === 'SUCCESS' && response.data.custom_menus.length > 0) {
        const data = response.data.custom_menus[0];
        this.customMenuId = data.id;
        this.menuItems[0].value = data.is_userdefined_page1_active === '1';
        this.menuItems[1].value = data.userdefined_page1_caption;
        this.menuItems[2].value = data.is_userdefined_page2_active === '1';
        this.menuItems[3].value = data.userdefined_page2_caption;
        this.menuItems[4].value = data.is_userdefined_page3_active === '1';
        this.menuItems[5].value = data.userdefined_page3_caption;
      }
      this.initForm();
      this.isFormDirty = false;
    });
  }

  initForm(): void {
    this.menuItems.forEach(item => {
      this.formData[item.key] = item.value;
    });
  }

  onSettingChange(event: any): void {
    this.formData[event.key] = event.value;
    this.isFormDirty = true;
  }

  onInputChange(key: string, event: any): void {
    this.formData[key] = event.target.value;
    this.isFormDirty = true;
  }

  getSettingValue(key: string): any {
    return this.formData[key];
  }

  async resetToDefault(): Promise<void> {
    if (this.isFormDirty) {
      const dialogData = new ConfirmDialogModel(
        "Discard Unsaved Changes?",
        "Are you sure you want to discard all changes? Any unsaved modifications will be lost."
      );

      const confirmed = await this.confirmDialogService.openDialog(dialogData);
      if (confirmed) {
        this.loadData();
      }
    } else {
      this.loadData();
    }
  }

  saveChanges(): void {
    if (this.isSaving) {
      return;
    }

    this.isSaving = true;

    // Prepare data for API
    const updateData = {
      id: this.customMenuId,
      is_userdefined_page1_active: this.formData.is_userdefined_page1_active ? '1' : '0',
      userdefined_page1_caption: this.formData.userdefined_page1_caption,
      is_userdefined_page2_active: this.formData.is_userdefined_page2_active ? '1' : '0',
      userdefined_page2_caption: this.formData.userdefined_page2_caption,
      is_userdefined_page3_active: this.formData.is_userdefined_page3_active ? '1' : '0',
      userdefined_page3_caption: this.formData.userdefined_page3_caption
    };

    this.customMenuService.update(updateData).subscribe({
      next: (response: any) => {
        this.isSaving = false;
        if (response.status === 'SUCCESS') {
          this.isFormDirty = false;
          let snackBarData: SnackBarData = {
            message: 'Custom menu updated successfully!',
            title: 'Success!',
            type: 'success'
          };
          this.snackBarService.openSnackBar(snackBarData);
        } else {
          let snackBarData: SnackBarData = {
            message: response.message || 'Failed to update custom menu.',
            title: 'Failed!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error: any) => {
        this.isSaving = false;
        let snackBarData: SnackBarData = {
          message: error.error?.message || 'Failed to save menu shortcuts. Please try again.',
          title: 'Failed!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  trackByKey(index: number, item: any): string {
    return item.key;
  }

  navigateToMenuItem() {
    this.router.navigate(['/user/custom-menu/menu-item']);
  }

}